import React from 'react';

import { useLoadColumns } from 'scenes/Trackers/Tracker/data';

import ColumnPicker from '../ColumnsPicker/ColumnsPicker';

const TrackerColumnPicker = ({ value, onClose, onSubmit, open, onExited }) => {
  const {
    data: metrics,
    isLoading: isLoadingMetrics,
    isRefetching: isRefetchingMetrics,
  } = useLoadColumns();

  return (
    <ColumnPicker
      value={value}
      metrics={metrics}
      onClose={onClose}
      onSubmit={onSubmit}
      loading={isLoadingMetrics}
      fetching={isRefetchingMetrics}
      open={open}
      onExited={onExited}
    />
  );
};

TrackerColumnPicker.displayName = 'ColumnsPicker';
export default TrackerColumnPicker;
